export const DEFINITIONS = {
  slug: 'store-locator',
  activeClass: 'selected',
  breakpoints: {
    UISwitch: 1024, // Adjust as needed
  },
};
